import { Button, Card } from "antd";
import { CheckCircleFilled, CloseOutlined } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";
import Confetti from "react-confetti";
import { useWindowSize } from "@react-hook/window-size";
import { ClosedCaptionIcon, CrossIcon, EyeClosed, X } from "lucide-react";

export default function PaymentSuccess() {
    const navigate = useNavigate();
    const location = useLocation();
    const [width, height] = useWindowSize();

    const creditsAdded = location.state?.creditsAdded || 100;
    const currentBalance = location.state?.currentBalance || 250;
    const status = location.state?.status;

    return (
        <>

            {
                status == 'SUCCESS' ?

                    <>
                        <Confetti
                            width={window.innerWidth}
                            height={window.innerHeight}
                            numberOfPieces={400}
                            gravity={0.15}
                            recycle={false}
                        />

                        <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
                            <Card className="w-full max-w-3xl rounded-3xl shadow-xl border-0">
                                <div className="text-center">
                                    <div className="mb-6">
                                        <CheckCircleFilled
                                            style={{
                                                fontSize: 120,
                                                color: "#22c55e",
                                            }}
                                        />
                                    </div>

                                    <h1 className="text-5xl font-extrabold text-slate-900">
                                        Credits Added Successfully!
                                    </h1>

                                    <p className="text-slate-500 text-xl mt-4">
                                        Your credits have been added to your account.
                                    </p>

                                    <div className="mt-10 bg-green-50 border border-green-100 rounded-3xl p-8">
                                        <div className="grid grid-cols-1 gap-8 items-center">


                                            <div className="text-center">
                                                <p className="text-slate-500 font-semibold">
                                                    Credits Added
                                                </p>

                                                <h2 className="text-3xl font-extrabold text-green-600">
                                                    +{creditsAdded} Credits
                                                </h2>

                                                <div className="border-t mt-4 pt-4">
                                                    <p className="text-slate-500">
                                                        Current Balance
                                                    </p>

                                                    <h3 className="text-2xl font-bold text-green-600">
                                                        {currentBalance} Credits
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <Button
                                        type="primary"
                                        size="large"
                                        className="mt-10 h-16 px-12 text-xl bg-green-600"
                                        onClick={() => navigate("/dashboard")}
                                    >
                                        Great! Continue →
                                    </Button>
                                </div>
                            </Card>
                        </div>  </> :

                    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
                        <Card className="w-full max-w-3xl rounded-3xl shadow-xl border-0">
                            <div className="text-center">
                               <div className="mb-6">
                                        <CloseOutlined
                                            style={{
                                                fontSize: 120,
                                                color: "red",
                                            }}
                                        />
                                    </div>

                                <h1 className="text-5xl font-extrabold text-slate-900">
                                    Payment Failed
                                </h1>

                              

                                <Button
                                    type="primary"
                                    size="large"
                                    className="mt-10 h-16 px-12 text-xl bg-red-600"
                                    onClick={() => navigate("/")}
                                >
                                    Go BACK →
                                </Button>
                            </div>
                        </Card>
                    </div>

            }
        </>
    );
}